import React, { useState } from 'react'
import { useTheme, Stack, Checkbox } from '@mui/material'
import { EventInPlanningDto } from '../../../services/api/sharedTypes/Event'
import EventDetailDialog from '../detail/EventDetailDialog'

interface EventSmallDetailForPlanningProps {
    event: EventInPlanningDto
    onEventChange: (event: EventInPlanningDto) => void
    onRefetch: () => void
}

const EventSmallDetailForPlanning: React.FC<EventSmallDetailForPlanningProps> = ({
    event,
    onEventChange,
    onRefetch,
}: EventSmallDetailForPlanningProps) => {
    const theme = useTheme()

    const [localEvent, setLocalEvent] = useState<EventInPlanningDto>(event)

    return (
        <Stack bgcolor={theme.palette.customBackground.default} padding={2}>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                {new Date(event.startsAt).toLocaleString('cs')}
                <Stack direction='row'>
                    <Checkbox
                        checked={localEvent.isEverythingReady}
                        onChange={(event) => {
                            setLocalEvent({ ...localEvent, isEverythingReady: event.target.checked })
                            onEventChange({ ...localEvent, isEverythingReady: event.target.checked })
                        }}
                    />
                    <EventDetailDialog onRefetch={onRefetch} eventId={event.id} />
                </Stack>
            </Stack>
            {`${localEvent.address?.street ?? ''} ${localEvent.address?.zip ?? ''} ${localEvent.address?.city ?? ''
                }`}
        </Stack>
    )
}

export default EventSmallDetailForPlanning
